import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { vaultApiRef } from '../api/VaultApi';
import type { VaultRequestRecord, VaultRequestEvent } from '../api/VaultApi';

interface UseVaultRequestResult {
  request: VaultRequestRecord | undefined;
  events: VaultRequestEvent[];
  loading: boolean;
  error: Error | undefined;
  reload: () => void;
}

export function useVaultRequest(
  requestId: string | undefined,
): UseVaultRequestResult {
  const vaultApi = useApi(vaultApiRef);
  const [request, setRequest] = useState<VaultRequestRecord | undefined>();
  const [events, setEvents] = useState<VaultRequestEvent[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>();
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!requestId) return undefined;
    let cancelled = false;
    setLoading(true);
    vaultApi
      .getRequest(requestId)
      .then(({ request: r, events: e }) => {
        if (!cancelled) {
          setRequest(r);
          setEvents(e);
          setError(undefined);
        }
      })
      .catch(err => {
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [requestId, vaultApi, tick]);

  return { request, events, loading, error, reload: () => setTick(t => t + 1) };
}
